// extracted by mini-css-extract-plugin
export default {"othersRegnJumbotron":"RegistrationTabs_othersRegnJumbotron__Z0Mf5","regnJumbotron":"RegistrationTabs_regnJumbotron__1Jrda","overlay":"RegistrationTabs_overlay__mKGLl"};